/** @typedef {Object} ALKResetPassword
 * @property {String} email
 * @property {String} newPassword
 * @property {String} token
 */

(function () {
  "use strict";

  angular
    .module("alk.authentication")
    .factory("ALKResetPassword", ALKResetPassword);

  /** @name ALKResetPassword
   * @ngdoc factory
   * @description A factory for an object that encapsulates reset password requests.
   * @param {String} email - email of the user resetting their password
   * @param {String} newPassword - the new password that will be set for the user
   * @param {String} token - the reset token for the user
   * @example
   * var reset = new ALKResetPassword(email, newPassword, token);
   * @returns ALKResetPassword
   * @memberof alk.authentication
   */
  function ALKResetPassword() {
    return function (email, newPassword, token) {
      this.email = email;
      this.newPassword = newPassword;
      this.token = token;
    };
  }
})();



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-authentication/factories/resetPassword.factory.js